import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function getPersonnelList(_x) {
  return _getPersonnelList.apply(this, arguments);
}
function _getPersonnelList() {
  _getPersonnelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(parma) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request("/personArchivesController/getPersonnelList", METHOD.POST, {
            name: parma
          }));
      }
    }, _callee);
  }));
  return _getPersonnelList.apply(this, arguments);
}
export function updatePassWord(_x2) {
  return _updatePassWord.apply(this, arguments);
}
function _updatePassWord() {
  _updatePassWord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parma) {
    var data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          data = {
            mobile: parma.mobile,
            oldPassWord: parma.oldPassWord,
            newPassWord: parma.pass
          };
          return _context2.a(2, request("/loginService/updatePassWord", METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _updatePassWord.apply(this, arguments);
}
export function updateUserSignature(_x3) {
  return _updateUserSignature.apply(this, arguments);
}
function _updateUserSignature() {
  _updateUserSignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/personArchivesController/updateUserSignature", METHOD.POST, params));
      }
    }, _callee3);
  }));
  return _updateUserSignature.apply(this, arguments);
}